import { jsx } from "react/jsx-runtime";
import React from "react";
import SelectionLayer from "./SelectionLayer";
import { connectToEditor } from "../withEditorProps";
import classNames from "classnames";
export const CutsiteSelectionLayers = connectToEditor(
  ({ hoveredAnnotation }) => ({
    hoveredAnnotation
  })
)(function CutsiteSelectionLayersInner({
  hoveredAnnotation,
  cutsites,
  annotationCommonProps,
  showReverseSequence,
  sequenceHeight,
  alignmentData,
  row
}) {
  return Object.keys(cutsites).sort((a) => cutsites[a].id === hoveredAnnotation ? 1 : -1).map(function(id, index) {
    const cutsite = cutsites[id];
    const isHovered = hoveredAnnotation === cutsite.id;
    const layer = cutsite.annotation.recognitionSiteRange;
    return layer.start > -1 && /* @__PURE__ */ jsx(
      SelectionLayer,
      {
        hideTitle: true,
        ...annotationCommonProps,
        ...{
          id: cutsite.id,
          height: showReverseSequence ? sequenceHeight * 2 : sequenceHeight,
          regions: [layer],
          row: alignmentData ? { start: 0, end: alignmentData.sequence.length - 1 } : row,
          className: classNames("cutsiteLabelSelectionLayer", {
            cutsiteLabelSelectionLayerHovered: isHovered
          }),
          hideCarets: true
        }
      },
      "restrictionSiteRange" + index
    );
  });
});
